import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9ac5dee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-module" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "search-bar" }
const _hoisted_4 = { class: "search-actions" }
const _hoisted_5 = { class: "toolbar" }
const _hoisted_6 = { class: "action-modal-content" }

import { computed, onMounted, reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import { queryProductListPage, type ProductListItem } from './index';

interface Product {
  id: string;
  name: string;
  itemNumber: string;
  code: string;
  chineseColor: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductList',
  setup(__props) {

const columns = [
  { title: '商品名称', dataIndex: 'name', key: 'name', ellipsis: true },
  { title: '型号', dataIndex: 'itemNumber', key: 'itemNumber', width: 160 },
  { title: '编码', dataIndex: 'code', key: 'code', width: 180 },
  { title: '颜色', dataIndex: 'chineseColor', key: 'chineseColor', width: 140 },
];

const loading = ref(false);
const dataSource = ref<Product[]>([]);
const tableScrollY = 460;
const actionModalVisible = ref(false);
const currentActionType = ref<'create' | 'import'>('create');
const searchForm = reactive({
  itemNumber: '',
  code: '',
  name: '',
});
const pagination = reactive({
  current: 1,
  pageSize: 15,
  total: 0,
  showSizeChanger: true,
  showQuickJumper: true,
  hideOnSinglePage: false,
  showTotal: (t: number) => `共 ${t} 条`,
});

async function fetchData() {
  loading.value = true;
  try {
    const pageData = await queryProductListPage({
      currentPage: pagination.current,
      size: pagination.pageSize,
      itemNumber: searchForm.itemNumber,
      code: searchForm.code,
      name: searchForm.name,
    });
    const rawList: ProductListItem[] = pageData.content;

    dataSource.value = rawList.map((item) => ({
      id: item.id,
      name: item.name ?? '-',
      itemNumber: item.itemNumber ?? '-',
      code: item.code ?? '-',
      chineseColor: item.chineseColor ?? '-',
    }));
    pagination.total = pageData.totalElements;
  } catch (error) {
    dataSource.value = [];
    pagination.total = 0;
    message.error(error instanceof Error ? error.message : '获取商品列表失败');
  } finally {
    loading.value = false;
  }
}

function handleTableChange(pag: typeof pagination) {
  pagination.current = pag.current;
  pagination.pageSize = pag.pageSize;
  fetchData();
}

function handleSearch() {
  pagination.current = 1;
  fetchData();
}

function handleReset() {
  searchForm.itemNumber = '';
  searchForm.code = '';
  searchForm.name = '';
  pagination.current = 1;
  fetchData();
}

function openActionModal(type: 'create' | 'import') {
  currentActionType.value = type;
  actionModalVisible.value = true;
}

function closeActionModal() {
  actionModalVisible.value = false;
}

const actionModalTitle = computed(() => (currentActionType.value === 'create' ? '新增' : '导入'));
const actionModalPlaceholder = computed(() =>
  currentActionType.value === 'create' ? '新增' : '你好导入逻辑',
);

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_form, {
          layout: "horizontal",
          model: searchForm,
          class: "search-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              gutter: [16, 0],
              class: "search-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "型号",
                      class: "search-form-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: searchForm.itemNumber,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.itemNumber) = $event)),
                          placeholder: "型号",
                          "allow-clear": "",
                          onPressEnter: handleSearch
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "商品名称",
                      class: "search-form-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: searchForm.name,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.name) = $event)),
                          placeholder: "商品名称",
                          "allow-clear": "",
                          onPressEnter: handleSearch
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "编码",
                      class: "search-form-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: searchForm.code,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.code) = $event)),
                          placeholder: "编码",
                          "allow-clear": "",
                          onPressEnter: handleSearch
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 6,
                  class: "search-actions-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        loading: loading.value,
                        onClick: handleSearch
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("搜 索")
                        ]),
                        _: 1
                      }, 8, ["loading"]),
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: handleReset
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("重置")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (openActionModal('create')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("新增")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (openActionModal('import')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("导入")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_a_table, {
        columns: columns,
        "data-source": dataSource.value,
        loading: loading.value,
        pagination: pagination,
        scroll: { y: tableScrollY },
        "row-key": "id",
        onChange: handleTableChange
      }, null, 8, ["data-source", "loading", "pagination", "scroll"]),
      _createVNode(_component_a_modal, {
        visible: actionModalVisible.value,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((actionModalVisible).value = $event)),
        title: _unref(actionModalTitle),
        footer: null,
        onCancel: closeActionModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(actionModalPlaceholder)), 1)
        ]),
        _: 1
      }, 8, ["visible", "title"])
    ])
  ]))
}
}

})